/**
 * Portal Entry Point for Media Domain
 *
 * Registers custom CRUD block and field components for media management.
 * Imported by the portal's virtual:portal-entries module.
 */

import { registerBlockComponent, registerFieldComponent } from '@ja/crud/services/componentRegistry'

// Register the MediaBlock for use in any CRUD config
registerBlockComponent(
  'Media::MediaBlock',
  () => import('./Components/MediaBlock.vue'),
  'media',
)

// Register the AvatarField for use inside blocks (customField)
registerFieldComponent(
  'Media::AvatarField',
  () => import('./Components/AvatarField.vue'),
  'media',
)

// Register the AvatarViewerBlock for read-only avatar display in viewers
registerBlockComponent(
  'Media::AvatarViewerBlock',
  () => import('./Components/AvatarViewerBlock.vue'),
  'media',
)
